<ion-app>
  <div class="flex min-h-screen">
    <!-- Sidebar -->
    <aside *ngIf="g.menuReady && !isLoginPage()">
      <app-sidebar></app-sidebar>
    </aside>

    <!-- Main Content -->
    <main
      [ngClass]="{ 'ml-64': g.menuReady && !isLoginPage() }"
      class="flex-1 py-3 px-5 bg-primaryBg"
    >
      <router-outlet></router-outlet>
    </main>
  </div>
</ion-app>
